import script from "./SwitchDeliver.vue?vue&type=script&lang=ts&setup=true"
export * from "./SwitchDeliver.vue?vue&type=script&lang=ts&setup=true"

import "./SwitchDeliver.vue?vue&type=style&index=0&id=57f2592f&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57f2592f"]])

export default __exports__